import { formatCompact } from "../utils/formatCompact";
import { REFERRAL_UNLOCK_SCORE } from "./constants";

export const REFERRAL_STATUS_META = {
  pending: { label: "Pending", tone: "warn" },
  rewarded: { label: "Claimed", tone: "live" },
  cancelled: { label: "Cancelled", tone: "muted" },
};

export function referralStatusMeta(status) {
  return REFERRAL_STATUS_META[status] || { label: status || "Unknown", tone: "muted" };
}

export function formatReferralCash(amount) {
  return `${formatCompact(Number(amount) || 0)} CASH`;
}

export function formatReferralDate(value, { withTime = false } = {}) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  });
}

export function formatDaysSince(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const days = Math.floor((Date.now() - date.getTime()) / (1000 * 60 * 60 * 24));
  if (days <= 0) return "Today";
  if (days === 1) return "1 day";
  return `${days} days`;
}

export function referralRowSubline(item) {
  const referrer = item?.referrer?.name || "Referrer";
  const referee = item?.referee?.name || "Referee";
  const amount = formatReferralCash(item?.rewardAmount);
  return `${referrer} → ${referee} · ${amount}`;
}

export function requirementLabel(key, threshold = REFERRAL_UNLOCK_SCORE) {
  switch (key) {
    case "score":
      return `Reach ${threshold} all-time score`;
    case "betting_activity":
      return "Place a qualifying bet";
    case "referee_ineligible":
      return "Referee account eligible";
    default:
      return key;
  }
}

export function referralHeat(item) {
  if (item?.status === "rewarded") return 100;
  if (item?.rewardReady) return 95;
  if (item?.status === "pending") {
    return Math.max(12, Math.round(Number(item.progressPercent) || 0));
  }
  return 8;
}
